import type { ReactNode } from 'react';
import type { UseFormRegisterReturn } from 'react-hook-form';
import { Link } from 'react-router';
import { LEGAL_PATHS } from './legal.config';

/** Frase do aceite, com os dois documentos em novas abas. */
export function ConsentText(): ReactNode {
  const link = 'font-medium text-primary underline underline-offset-4';
  return (
    <>
      Li e aceito os{' '}
      <Link to={LEGAL_PATHS.terms} target="_blank" rel="noopener noreferrer" className={link}>
        Termos de Uso
      </Link>{' '}
      e a{' '}
      <Link to={LEGAL_PATHS.privacy} target="_blank" rel="noopener noreferrer" className={link}>
        Política de Privacidade
      </Link>
      .
    </>
  );
}

/**
 * Checkbox obrigatório do aceite (cadastro e convite). Nativo e uncontrolled: `inputProps` vem do `register` do react-hook-form.
 * O rótulo envolve o campo (alvo de toque amplo); os links dentro do rótulo não marcam a caixa.
 */
export function TermsConsentField({ inputProps, error }: { inputProps: UseFormRegisterReturn; error?: string }) {
  return (
    <div className="grid gap-1.5">
      <label className="flex min-h-11 items-start gap-3 text-sm leading-snug">
        <input
          type="checkbox"
          id="acceptTerms"
          className="mt-0.5 size-5 shrink-0 accent-[var(--bottle,#1F4A3D)]"
          aria-invalid={Boolean(error)}
          aria-describedby={error ? 'acceptTerms-error' : undefined}
          {...inputProps}
        />
        <span>
          <ConsentText />
        </span>
      </label>
      {error && (
        <p id="acceptTerms-error" role="alert" className="text-xs text-destructive">
          {error}
        </p>
      )}
    </div>
  );
}
